/**
 * 权限组
 */
export type TPermissionGroup = {
  id?: string;
  /**
   * 权限组名称
   */
  name: string;
  /**
   * 权限组类型
   */
  type: EPermissionGroupType;
  /**
   * 权限组角色
   */
  selected?: TSelected;
  /**
   * 权限组权限
   */
  permission?: any;
  /**
   * 关联id
   */
  relationId?: string;
};

export type TSelected = {
  /**
   * 角色
   */
  roleList: TPermissionRole[];
  /**
   * 人员
   */
  personList: TPermissionPerson[];
};

export type TPermissionRole = {
  /**
   * 角色id
   */
  id: number;
  /**
   * 角色名称
   */
  name: string;
};

export type TPermissionPerson = {
  pernr: string; // 工号
  nameEn: string;
  nameZh: string;
};

export enum EPermissionGroupType {
  /**
   * 谁可以新建打卡营
   */
  CREATE_CAMP,
  /**
   * 谁可以管理所有打卡营
   */
  MANAGE_CAMP,
  /**
   * 谁可以使用题库管理
   */
  MANAGE_QUESTION_BANK,
}